import { boot } from 'quasar/wrappers'
import { getLanguage } from '../functions/language-helper'

export default boot(({ app }) => {
	app.config.globalProperties.$getLanguage = getLanguage
})
